import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from '@wegroup/design-system';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const ResetCompanyScanAlertDialog: React.FC<Props> = ({
  isOpen,
  onConfirm,
  onClose,
  isLoading,
}) => {
  const { t } = useTranslation();
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      motionPreset="slideInBottom"
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {t('Are you sure?')}
          </AlertDialogHeader>

          <AlertDialogBody>
            {t('FLOWS_RESTART_ALERT-DIALOG_DESCRIPTION')}
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button variant="grayedGhost" ref={cancelRef} onClick={onClose}>
              {t('CANCEL')}
            </Button>
            <Button isLoading={isLoading} onClick={onConfirm} ml={3}>
              {t('Confirm')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default ResetCompanyScanAlertDialog;
